module.exports = __webpack_public_path__ + "static/media/c2cActiveIcon.367369d3.svg";